module.exports = __webpack_public_path__ + "static/media/korean-flag.7c3ae1f3.png";